// removed by extract-text-webpack-plugin
module.exports = {"tier":"tier__3eQEV","price":"price__379XL","card-content":"card-content__NxZhz"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Billing/coms/PayStrategy/styles.scss
// module id = 2255
// module chunks = 1